import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import menus from '../../pages/menu';
import './styles.scss';
import logo from '../../assets/images/logo/logo.png';
import logodark from '../../assets/images/logo/logo-dark.png';
import DarkMode from './DarkMode';
import { ConnectButton } from '@rainbow-me/rainbowkit';
// import Button from '../button';

const Header = () => {
  const [scroll, setScroll] = useState(false);
  const [menuActive, setMenuActive] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const menuRef = useRef();
  const menuButtonRef = useRef();
  const handleMenuActive = (isActive) => {
    setMenuActive(isActive);
  };

  const handleDropdown = (index) => {
    setActiveIndex(index);
  };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setScroll(window.scrollY > 300);
    });
    return () => {
      setScroll({});
    };
  }, []);

  useEffect(() => {
    let handler = (e) => {
      if (!menuRef.current.contains(e.target)) {
        handleMenuActive(false);
      }
      if (
        menuButtonRef.current.contains(e.target) &&
        menuButtonRef.current.className !== 'mobile-button active'
      ) {
        handleMenuActive(true);
      }
    };
    document.addEventListener('mousedown', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
    };
  });

  return (
    <header id="header_main" className={`header ${scroll ? 'is-fixed' : ''}`}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="header__body d-flex justify-content-between">
              <div className="header__left">
                <div className="logo">
                  <NavLink to="/" className="light">
                    <img src={logo} alt="Rockie" />
                  </NavLink>
                  <NavLink to="/" className="dark">
                    <img src={logodark} alt="Rockie" />
                  </NavLink>
                </div>
                <div className="left__main">
                  <nav
                    ref={menuRef}
                    id="main-nav"
                    className={`main-nav ${menuActive ? 'active' : ''}`}
                  >
                    <ul id="menu-primary-menu" className="menu">
                      {menus.map((data, idx) => (
                        <li
                          key={idx}
                          onClick={() => {
                            handleDropdown(idx);
                            handleMenuActive(false);
                          }}
                          className={`menu-item ${data.namesub ? 'menu-item-has-children' : ''
                            } ${activeIndex === idx ? 'active' : ''}`}
                        >
                          {/* {idx === 4 ? (
                            <a href={data.links} target="_blank">
                              {data.name}
                            </a>
                          ) : (
                            <Link to={data.links}>{data.name}</Link>
                          )} */}
                        
                            <Link to={data.links}>{data.name}</Link> 
                          {data.namesub && (
                            <ul className="sub-menu">
                              {data.namesub.map((submenu) => (
                                <li key={submenu.id} className="menu-item">
                                  <NavLink to={submenu.links}>
                                    {submenu.sub}
                                  </NavLink>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  </nav>
                </div>
              </div>

              <div className="header__right">
                <DarkMode />

                <div
                  ref={menuButtonRef}
                  className={`mobile-button ${menuActive ? 'active' : ''}`}
                >
                  <span></span>
                </div>
                <div className="dropdown notification"></div>

                <div className="wallet">
                  <ConnectButton showBalance={false} chainStatus="none" />
                  <style>
                    {`
                      .wallet button {
                        background-color: #119f24 !important;   
                      }
                       
                    `}
                  </style>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
